"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkBrowser = checkBrowser;
var _ReadinessCheck = require("@studio/constants/ReadinessCheck");
function checkBrowser() {
  var userAgent = navigator.userAgent;
  var isChromium = userAgent.includes('Chrome') || userAgent.includes('Chromium') || userAgent.includes('Edg');
  if (!isChromium) {
    console.warn('ReadinessCheck - Unsupported browser:', userAgent);
  }
  return {
    status: isChromium ? _ReadinessCheck.PASSED : _ReadinessCheck.FAILED
  };
}